import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import ProblemRequests from "./ProblemRequests";
import { SCIENCE_LINKS, SOLUTION_AREAS } from "../../content/siteContent";
import "./HomeSections.css";

const solutionPaths = [
  {
    number: "01",
    title: SOLUTION_AREAS[0].title,
    description: "We help you get an assay running on your instruments.",
    href: SOLUTION_AREAS[0].href,
  },
  {
    number: "02",
    title: SOLUTION_AREAS[1].title,
    description: "Bring experiment records and instrument files into a dataset you can use.",
    href: SOLUTION_AREAS[1].href,
  },
  {
    number: "03",
    title: SOLUTION_AREAS[2].title,
    description: "Tools, permissions and evaluations for scientific agents.",
    href: SOLUTION_AREAS[2].href,
  },
];

const fieldNotes = [
  {
    number: "01",
    title: "Where a general model loses the biology",
  },
  {
    number: "02",
    title: "What belongs in a scientist’s assistant?",
  },
  {
    number: "03",
    title: "Learning from experiments that didn’t work",
  },
];

export function HomeConviction() {
  return (
      <section
        className="home-editorial-conviction home-editorial-shell"
        aria-labelledby="home-conviction-heading"
        id="platform"
      >
        <div className="home-editorial-conviction-copy" style={{ gridColumn: "1 / -1" }}>
          <h2 id="home-conviction-heading">
            We believe the biggest problems in biology cannot be solved by{" "}
            <span>general AI systems.</span>
          </h2>
        </div>
      </section>
  );
}

export function FieldNotes({ asPage = false, contactPath = "/contact" }) {
  const Heading = asPage ? "h1" : "h2";
  return (
      <section
        className="home-editorial-notes home-editorial-shell"
        id="field-notes"
        aria-labelledby="home-notes-heading"
      >
        <div className="home-editorial-notes-intro">
          <Heading id="home-notes-heading">
            Field <span>notes.</span>
          </Heading>
          <p className="home-editorial-support" id="field-notes-status">
            We’re still writing these. If one catches your eye, let’s talk.
          </p>
          <Link className="home-editorial-text-link home-editorial-notes-contact" to={`${contactPath}?source=field-notes`}>
            {contactPath === SCIENCE_LINKS.contact.to ? SCIENCE_LINKS.contact.label : "Get in touch"} <ArrowUpRight size={17} aria-hidden="true" />
          </Link>
        </div>
        <div className="home-editorial-note-list" aria-describedby="field-notes-status">
          {fieldNotes.map((note) => (
            <article className="home-editorial-note" key={note.number}>
              <p className="home-editorial-note-meta">Coming soon</p>
              <h3 className="home-editorial-note-title">{note.title}</h3>
            </article>
          ))}
        </div>
      </section>
  );
}

export function HomeInvitation() {
  return (
      <section
        className="home-editorial-invitation"
        aria-labelledby="home-invitation-heading"
      >
        <div className="home-editorial-shell">
          <div className="home-editorial-invitation-content">
            <h2 id="home-invitation-heading">
              What are you <span>working on?</span>
            </h2>
            <Link
              className="home-editorial-contact"
              to="/contact?source=home-mission"
              data-solution-id="workflow-review"
              data-cta="discuss-project"
            >
              Start a conversation
              <ArrowUpRight size={21} aria-hidden="true" />
            </Link>
          </div>
        </div>
      </section>
  );
}

function HomeSections() {
  return (
    <div className="home-editorial">
      <HomeConviction />

      <section
        className="home-editorial-solutions home-editorial-shell"
        aria-labelledby="home-solutions-heading"
        id="ai-infrastructure"
      >
        <div className="home-editorial-section-heading">
          <div>
            <h2 id="home-solutions-heading">
              How we can <span>help.</span>
            </h2>
          </div>
          <Link className="home-editorial-text-link" to="/solutions">
            Explore solutions <ArrowUpRight size={17} aria-hidden="true" />
          </Link>
        </div>

        <div className="home-editorial-solution-list">
          {solutionPaths.map((solution) => (
            <Link
              key={solution.number}
              className="home-editorial-solution"
              to={solution.href}
            >
              <span className="home-editorial-index" aria-hidden="true">
                {solution.number}
              </span>
              <div className="home-editorial-solution-name">
                <h3>{solution.title}</h3>
              </div>
              <p className="home-editorial-solution-description">
                {solution.description}
              </p>
              <ArrowUpRight
                className="home-editorial-solution-arrow"
                strokeWidth={1.3}
                aria-hidden="true"
              />
            </Link>
          ))}
        </div>
      </section>

      <ProblemRequests />

      <FieldNotes />

      <HomeInvitation />
    </div>
  );
}

export default HomeSections;
